// Copyright (c) 2016 Deere & Company

import KeyValueCollection, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../action-list';

const setReasonsForReturn = (state, action) =>
    KeyValueCollection.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.SET_CLAIM_JDP_REASONS]: setReasonsForReturn
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/reducers/reasons-for-return.js